export default "__VITE_ASSET__CefA5mY___"